import React from 'react';
import MarkdownViewer from './MarkdownViewer';

function CancellationPolicy() {
  return (
    <MarkdownViewer
      title="Cancellation Policy"
      fileName="CANCELLATION_POLICY.md"
    />
  );
}

export default CancellationPolicy;
